import { variables } from '~/config/variables.client'

export async function getCaptchaToken(action: string): Promise<string> {
  if (!window.grecaptcha?.enterprise) {
    throw new Error('reCAPTCHA not loaded')
  }
  await new Promise<void>(resolve => {
    window.grecaptcha?.enterprise?.ready(() => resolve())
  })
  return window.grecaptcha.enterprise.execute(variables.RECAPTCHA_SITE_KEY, {
    action,
  })
}
